import { useState } from "react";

// we should test this and we will create a task for this when we move this repo to vite or other alternative
export const useSteps = (totalSteps: number, initialStep?: number) => {
  const [step, setStep] = useState(initialStep || 0);

  const nextStep = () => {
    if (step + 2 <= totalSteps) {
      setStep(step + 1);
    }
  };

  const previousStep = () => {
    if (step - 1 >= 0) {
      setStep(step - 1);
    }
  };

  const goToStep = (stepIndex: number) => {
    if (stepIndex >= 0 && stepIndex + 1 <= totalSteps) {
      setStep(stepIndex);
    }
  };

  return {
    currentStep: step,
    nextStep,
    previousStep,
    goToStep,
  };
};
